<template>
  <div class="row">
    <div class="col-12">
      
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing contact-card"
      >
        <div class="card-body p-20 p-md-25 p-lg-30">
          <div class="mb-2" style="border-bottom: 1px dashed #d2cfe4;">
           <div
            class="user-info d-sm-flex align-items-center justify-content-between mb-30"
          >
            <div class="d-flex align-items-center">
              <div class="image">
                <img v-if="userData?.pic"
                  :src="userData.pic"
                  class="rounded-circle"
                  width="85"
                  height="85"
                  alt="user"
                />

                 <img
                  v-else
                  :src="require('@/assets/images/NoImage.png')"
                  class="rounded-circle"
                  width="85"
                  height="85"
                  alt="user"
                />
              </div>
              <div class="ms-15 ms-md-20">
                <h5 class="text-black fw-black mb-1">{{ userData?.name }}</h5>
                <span class="d-block text-muted">{{ userData?.email }}</span>
                <span
                  class="d-block text-black fs-md-15 fs-lg-16 fw-medium mb-8"
                >
                  {{ userData?.type }}
                </span>
              </div>
            </div>
          </div> 
          </div>
           

          <form @submit.prevent="saveProfile">
            <div class="row mb-4">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="ex: Adam"
                    v-model="userData.name"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    CIN
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="ex: AB123456"
                    v-model="userData.cin"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse e-mail
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="ex: adam127704@gmail.com"
                    v-model="userData.email"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="ex: +212 600 000000"
                    v-model="userData.phone"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mot de passe
                  </label>
                  <input
                    type="password"
                    v-model="userData.password"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="ex: **************"
                    autocomplete="new-password"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Confirmer le mot de passe
                  </label>
                  <input
                    type="password"
                    v-model="userData.password_confirmation"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="ex: **************"
                    autocomplete="new-password"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse
                  </label>
                  <textarea
                    class="form-control shadow-none fs-md-15 text-black"
                    v-model="userData.adresse"
                  ></textarea>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Photo de profil
                  </label>
                  <input
                    class="form-control fs-15 text-black shadow-none"
                    type="file"
                    id="formFile"
                    accept="image/*"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                  >
                    Enregistrer le profil
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "AboutContent",
  components: {},
  setup() {
    const auth = useAuthStore();
    const user = auth.user;
    const userData = reactive<Record<string, any>>({});
    const { showToast } = useAppToast();

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/user_account/${user?.id}`);
        Object.assign(userData, response.data); // copy all keys into the reactive object
      } catch (error) {
        console.error("Error fetching user account:", error);
        showToast("Impossible de charger les informations du profil", "error");
      }
    });

    // n'ajoute le champ que si la valeur existe, pour ne jamais envoyer "null"/"undefined" au serveur
    const appendIfPresent = (formData: FormData, key: string, value: any) => {
      if (value !== null && value !== undefined && value !== "") {
        formData.append(key, value);
      }
    };

    // Save Profile function
    const saveProfile = async () => {
      if (!userData.name || !userData.email) {
        showToast("Merci de remplir le nom et l'e-mail", "error");
        return;
      }

      if (userData.password && userData.password !== userData.password_confirmation) {
        showToast("Les mots de passe ne correspondent pas", "error");
        return;
      }

      try {
        const formData = new FormData();
        appendIfPresent(formData, "name", userData.name);
        appendIfPresent(formData, "cin", userData.cin);
        appendIfPresent(formData, "email", userData.email);
        appendIfPresent(formData, "phone", userData.phone);
        appendIfPresent(formData, "adresse", userData.adresse);

        // Handle optional password
        if (userData.password) {
          appendIfPresent(formData, "password", userData.password);
          appendIfPresent(
            formData,
            "password_confirmation",
            userData.password_confirmation
          );
        }

        // Handle file (profile picture)
        const fileInput = document.querySelector<HTMLInputElement>("#formFile");
        if (fileInput?.files?.[0]) {
          formData.append("pic", fileInput.files[0]);
        }

        const response = await api.post(
          `/api/auth/edit_user1/${auth.user?.id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success || response.data.message === "success") {
          showToast("Profil enregistré avec succès", "success");
          userData.password = "";
          userData.password_confirmation = "";
        } else {
          console.error("Profile update failed:", response.data);
          showToast("Une erreur est survenue lors de l'enregistrement du profil", "error");
        }
      } catch (error: any) {
        console.error(
          "Error saving profile:",
          error.response?.data || error.message
        );
        showToast("Une erreur est survenue lors de l'enregistrement du profil", "error");
      }
    };
    return {
      user,
      userData,
      saveProfile,
    };
  },
});
</script>